import { activityFeedTitle } from 'owa-locstrings/lib/strings/activityfeedtitle.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import HeaderPaneProps from './HeaderPaneProps';
import { observer } from 'mobx-react-lite';
import { ActivityFeed } from 'owa-activity-feed';

import popoutReadingPane from 'owa-popout-utils/lib/utils/popoutReadingPane';

const activityFeedActions = {
    openMail: (messageId: string) =>
        popoutReadingPane(/* itemId */ null, /* internetMessageId */ messageId),
};

const ActivityFeedPane = observer(function ActivityFeedPane(props: HeaderPaneProps) {
    return (
        <HeaderFlexPane
            title={loc(activityFeedTitle)}
            content={<ActivityFeed actions={activityFeedActions} />}
            onDismiss={props.onDismiss}
        />
    );
});
export default ActivityFeedPane;
